import Navbar from '../home/components/Navbar';
import Gallery from '../home/components/Gallery';
import Footer from '../home/components/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function GalleryPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": siteUrl
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Gallery",
            "item": `${siteUrl}/gallery`
          }
        ]
      },
      {
        "@type": "ImageGallery",
        "name": "King Square Club Gallery",
        "description": "Explore stunning moments from King Square Club's exclusive events, VIP experiences, and unforgettable nights in Benin City's premier luxury nightclub.",
        "url": `${siteUrl}/gallery`,
        "about": {
          "@type": "NightClub",
          "name": "King Square Club",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "148 Airport Rd",
            "addressLocality": "Benin City",
            "addressRegion": "Edo",
            "addressCountry": "NG"
          }
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-black">
      <SEOHead
        title="Gallery - King Square Club | Exclusive Nightclub Moments in Benin City"
        description="Explore stunning moments from King Square Club's exclusive events, VIP experiences, and unforgettable nights in Benin City's premier luxury nightclub."
        keywords="King Square Club gallery, Benin City nightclub photos, luxury nightlife images, VIP club photos Nigeria, nightclub gallery Edo"
        canonical={`${siteUrl}/gallery`}
        ogTitle="Gallery - King Square Club"
        ogDescription="Explore stunning moments from our exclusive events and VIP experiences."
        ogImage="https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/52d59385496b333797e917eef1b3302a.jpeg"
        ogType="website"
        jsonLd={jsonLd}
      />
      <Navbar />
      <div className="pt-24">
        <Gallery />
      </div>
      <Footer />
    </div>
  );
}
